import { Component, computed, inject } from '@angular/core';
import { MatDivider, MatListItem, MatNavList } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import { MultiTenantStore } from '@raxapp/multi-tenants/MultiTenant.store';

interface Tenant {
    name: string;
    id: string;
    routerLink: string;
}

@Component({
    selector: 'rax-multi-tenant-tenant-list-page',
    templateUrl: './tenant-list-page.component.html',
    imports: [MatNavList, MatDivider, MatListItem, RouterLink],
})
export class MultiTenantTenantListPage {
    private readonly multiTenantStore = inject(MultiTenantStore);

    public tenants = computed(() =>
        this.multiTenantStore.tenants().map(
            (tenant) =>
                ({
                    id: tenant.tenantId,
                    name: tenant.tenantName,
                    routerLink: `/t/${tenant.tenantIdCode}`,
                }) as Tenant,
        ),
    );
}
